import styled from 'styled-components'
import { Box } from 'rebass'
import { rem } from 'polished'

const PseudoSeparator = styled(Box)`
  display: inline-block;
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  font-weight: ${(props) => props.theme.weights[1]};
  color: ${(props) => props.theme.colors.grey_light};
  text-transform: uppercase;
  text-align: center;
  align-self: center;
`

PseudoSeparator.displayName = 'PseudoSeparator'

export default PseudoSeparator
